// src/subscreens/admin/support/ticketHeader/AdminTicketHeader.jsx
// FIX: customer object ko string mein convert karo

import React from 'react';
import { FiFileText, FiAlertCircle, FiUser, FiMail } from 'react-icons/fi';
import '../../../../assets/css/admin/subscreens/support/AdminTicketHeader.css';

const AdminTicketHeader = ({ ticketId, customer, email, subject, status, priority }) => {
const safeStr = (val) => {
  if (!val) return '—';
  if (typeof val === 'string') return val;
  if (typeof val === 'object') {
    if (val.first_name) return `${val.first_name} ${val.last_name || ''}`.trim();
    return val.full_name || val.store_name || val.name || '—';
  }
  return String(val);
};
  const customerName = safeStr(customer);
  const customerEmail = safeStr(email);

  const getStatusClass = (s) => {
    const map = { 'Open': 'atv-status-open', 'In Progress': 'atv-status-progress', 'Resolved': 'atv-status-resolved', 'Closed': 'atv-status-closed' };
    return map[s] || 'atv-status-open';
  };

  const getPriorityClass = (p) => {
    const map = { 'High': 'atv-priority-high', 'Medium': 'atv-priority-medium', 'Low': 'atv-priority-low' };
    return map[p] || 'atv-priority-medium';
  };

  return (
    <div className="atv-header">
      <div className="atv-header-left">
        <div className="atv-header-icon"><FiFileText /></div>
        <div>
          <h1 className="atv-header-id">{ticketId}</h1>
          <p className="atv-header-subject">{safeStr(subject)}</p>
          <div className="atv-customer-info">
            {/* <span className="atv-customer-detail"><FiUser size={14} /> {customerName}</span> */}
            <span className="atv-customer-detail"><FiMail size={14} /> {customerEmail}</span>
          </div>
        </div>
      </div>
      <div className="atv-header-right">
        <div className="atv-header-badges">
          <span className={`atv-status-badge ${getStatusClass(status)}`}>{safeStr(status)}</span>
          {priority && (
            <span className={`atv-priority-badge ${getPriorityClass(priority)}`}>
              <FiAlertCircle /> {safeStr(priority)} Priority
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminTicketHeader;